import { Body } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { AccessPolicy, UserGroupAccessPolicyType } from '@mews-commander/data-access';

export const AccessPolicyCell = ({ accessPolicy }: { accessPolicy?: AccessPolicy | null }) => {
    if (!accessPolicy || accessPolicy.accessPolicyType === UserGroupAccessPolicyType.NoAccess) {
        return <>{UnicodeEntity.Dash}</>;
    }

    if (accessPolicy.accessPolicyType === UserGroupAccessPolicyType.Admin) {
        return <LocalizedText textKey={TextKey.IsAdmin} />;
    }

    return (
        <Body size="small" ellipsis maxLines={1}>
            {accessPolicy.roles?.map((r) => r.name).join(', ') || UnicodeEntity.Dash}
        </Body>
    );
};
